import { Box, Card, Grid, Skeleton } from '@mui/material';
import CardView from '../../../component/card/card-view';

/**
 * 授权点 骨架屏
 */
export default function AuthCardSkeleton() {
    const arr = new Array(6).fill(null);
    return (
        <Box display={'flex'} flexWrap='wrap'>
            {arr.map((_item, index) => {
                return (
                    <Box key={index} style={{ margin: '10px' }} >
                        <Skeleton variant='rounded' width={195} height={235} animation='wave' />
                    </Box>
                )
            })}
        </Box >
    )
}
/**
 * 授权方案 弹窗骨架屏
 * @returns
 */
export function AuthCardDialogSkeleton() {
    const arr1 = new Array(17).fill(null);
    const arr2 = new Array(4).fill(null);
    return (
        <Box>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={130} height={40} animation='wave' />
                                </Grid>
                                <Grid item xs={12} columnSpacing={5} display={'flex'}
                                    flexWrap='wrap' >
                                    {arr1.map((_item, index) => {
                                        return (
                                            <Skeleton key={index} variant='rounded' sx={{ margin: '0px 10px 10px 0' }} width={195} height={235} animation='wave' />
                                        )
                                    })}
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
                <Grid item xs={12}>
                    <CardView
                        style={{ height: '100%' }}
                        contentRender={(
                            <Grid container rowSpacing={4}>
                                <Grid item xs={12}>
                                    <Skeleton variant='rounded' width={130} height={40} animation='wave' />
                                </Grid>
                                <Grid item xs={12} columnSpacing={5} display={'flex'}
                                    flexWrap='wrap' >
                                    {arr2.map((_item, index) => {
                                        return (
                                            <Skeleton key={index} variant='rounded' sx={{ margin: '0px 10px 10px 0' }} width={195} height={235} animation='wave' />
                                        )
                                    })}
                                </Grid>
                            </Grid>
                        )}
                    />
                </Grid>
            </Grid>
        </Box >
    )
}


/**
 * 购买授权点 骨架屏
 */
export function AuthPointSkeleton({ num }: { num: number }) {
    const arr = new Array(num).fill(null);
    return (
        <Card className=' ' style={{ margin: '1rem' }}>
            {arr.map((item, index) => (
                <Grid container key={index}>
                    <Grid item>
                        <Box sx={{ margin: '10px' }} >
                            <Skeleton variant='rounded' width={195} height={235} animation='wave' />
                        </Box>
                    </Grid>
                    <Grid item >
                        <Box sx={{ padding: '1rem' }} >
                            <Skeleton variant='rounded' width={200} height={40} animation='wave' />
                        </Box>
                        <Box sx={{ padding: '1rem' }} >
                            <Skeleton variant='rounded' width={220} height={112} animation='wave' />
                        </Box>
                    </Grid>
                </Grid>
            ))}
        </Card>
    )
}